export default __webpack_public_path__ + "static/hetzner_community_7-9e1ac3b1721cf7784d438b41a16ca75b.jpg";